import { useEffect, useState } from 'preact/hooks'
import styles from '../ui.module.css'

/** Whole seconds left of `holdMs` after `elapsedMs`, rounded up, never below 0. */
export function closeSecondsLeft(holdMs: number, elapsedMs: number): number {
  return Math.max(0, Math.ceil((holdMs - elapsedMs) / 1000))
}

/** The line under a private room's results: "Room closes in 12s", then "Room closing…". */
export function roomCloseText(secondsLeft: number): string {
  return secondsLeft > 0 ? `Room closes in ${secondsLeft}s` : 'Room closing…'
}

/**
 * A private room's results (D-066): the server closes the room `resultsHoldMs` after the race
 * ends (`balance.match`), and its code with it, so the time left to Rematch is shown, counted
 * from when the results came up.
 */
export function RoomCloseCountdown({ holdMs }: { holdMs: number }) {
  const [start] = useState(() => performance.now())
  const [elapsed, setElapsed] = useState(0)
  useEffect(() => {
    const id = setInterval(() => setElapsed(performance.now() - start), 250)
    return () => clearInterval(id)
  }, [start])
  return (
    <p class={styles.status} data-testid="room-close">
      {roomCloseText(closeSecondsLeft(holdMs, elapsed))}
    </p>
  )
}
